import { Box, Stack, styled } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import pxToRem from "theme/base/pxToRem";

export const Tabs = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: pxToRem(16),
  margin: `${pxToRem(20)} ${pxToRem(16)}`,
}));

export const Tab = styled(Box)<{ active?: boolean }>(({ theme, active }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: `${pxToRem(10)} ${pxToRem(16)}`,
  backgroundColor: active
    ? theme.palette.background.bgBrandPrimary
    : theme.palette.background.bgTertiary,
  color: active
    ? theme.palette.text.textLink
    : theme.palette.text.textSecondary,
  borderRadius: pxToRem(8),
  textAlign: "center",
  cursor: "pointer",
}));

export const TabContent = styled(Box)(({ theme }) => ({
  overflow: "scroll",
  flex: 1,
  height: "100%",
  margin: `0 ${pxToRem(16)}`,
  table: {
    thead: {
      th: {
        div: {
          justifyContent: "right",
        },
      },
    },
    tbody: {
      tr: {
        td: {
          width: "100%",
          textAlign: "right",
          justifyContent: "flex-end",
        },
      },
    },
  },
}));

export const BoxIconHoliday = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  svg: {
    path: {
      fill: theme.palette.colorsBase.violet_0,
    },
  },
}));

export const DatePickerCustom = styled(DatePicker)(({ theme }) => ({
  fieldset: {
    border: "none",
  },
  ".MuiInputBase-root.MuiOutlinedInput-root": {
    paddingRight: 0,
    input: {
      width: pxToRem(80),
      textTransform: "capitalize",
      fontSize: pxToRem(18),
      paddingLeft: pxToRem(4),
      fontWeight: theme.typography.fw_semibold_600,
    },
  },
  ".MuiInputAdornment-root.MuiInputAdornment-positionEnd": {
    opacity: 0,
    position: "absolute",
    right: pxToRem(50),
    button: {
      width: pxToRem(140),
      marginRight: `-${pxToRem(75)}`,
    },
  },
}));
